import { observer } from 'mobx-react-lite';
import React from 'react';

import type { IEvent } from '@feathr/blackbox';
import { Button, Form, SaveButton, Toolbar } from '@feathr/components';
import type { Model } from '@feathr/rachis';

import styles from './EventAddStepThree.css';

interface IProps {
  event: Model<IEvent>;
  onPrevious: () => void;
  onSave: (model: Model<IEvent>) => void;
}

function EventAddStepThree({ event, onPrevious, onSave }: IProps) {
  return (
    <Form
      description={'That\'s all! Click "Finish" to create your Project and take flight.'}
      label={'Create a Project: Finish'}
    >
      <Toolbar className={styles.toolbar}>
        <SaveButton
          errorMessage={'Something went wrong while adding your Project. Please try again later.'}
          key={'finish'}
          method={'add'}
          model={event}
          onSave={onSave}
          preSave={(preSaveModel) => {
            if (!preSaveModel.isValid(['name'], false)) {
              throw new Error('Project is not configured correctly.');
            }
          }}
          successMessage={`Successfully added new Project: "${event.get('name')}".`}
        >
          Finish
        </SaveButton>
        <Button key={'previous'} onClick={onPrevious} type={'naked'}>
          Previous
        </Button>
      </Toolbar>
    </Form>
  );
}

export default observer(EventAddStepThree);
